import { Link } from "react-router-dom";
import { Crosshair } from "lucide-react";

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-border bg-background">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 grid md:grid-cols-3 gap-12">
      <div>
        <div className="flex items-center gap-2.5 mb-4">
          <span className="w-7 h-7 border border-foreground flex items-center justify-center">
            <Crosshair className="w-4 h-4" />
          </span>
          <span className="font-display font-extrabold tracking-tight text-lg">GeoVerify</span>
        </div>
        <p className="text-sm text-muted-foreground max-w-xs leading-relaxed">
          The neutral truth layer for delivery networks. We don&apos;t replace your tools — we verify them.
        </p>
      </div>
      <div className="font-mono text-xs tracking-widest uppercase space-y-3">
        <p className="text-muted-foreground mb-4">Index</p>
        <p><Link data-testid="footer-docs-link" to="/docs" className="hover:text-telemetry transition-colors duration-200">Developer Docs</Link></p>
        <p><Link data-testid="footer-faq-link" to="/faq" className="hover:text-telemetry transition-colors duration-200">FAQ</Link></p>
        <p><Link data-testid="footer-playground-link" to="/playground" className="hover:text-telemetry transition-colors duration-200">API Playground</Link></p>
        <p><a data-testid="footer-access-link" href="/#request-access" className="hover:text-telemetry transition-colors duration-200">Request Access</a></p>
      </div>
      <div className="font-mono text-xs leading-loose text-muted-foreground">
        <p>SOC 2-ALIGNED CONTROLS</p>
        <p>IMMUTABLE AUDIT TRAILS · SHA-256 CHAINED</p>
        <p>WGS-84 COORDINATE VALIDATION</p>
        <p className="mt-6 text-foreground">© 2026 GEOVERIFY SYSTEMS</p>
      </div>
    </div>
  </footer>
);

export default Footer;
